<template>
  <popup
    :close-on-click-overlay="false"
    :style="{ height:'9.7rem' }"
    :value="show"
    @click-overlay="close"
    @close="close"
    position="bottom"
    safe-area-inset-bottom
  >
    <div @click.stop class="address-choose">
      <div class="title">
        <button @click="back" class="back" v-show="showBack && Authorization && addressList.length">
          <img alt src="../../assets/img/arrow-right.png" />
          <span>返回</span>
        </button>
        <span>{{modelTitle}}</span>
        <button @click="close" class="close">关闭</button>
      </div>
      <div class="user-address-list auto-y" v-if="!showBack && Authorization && addressList.length">
        <div class="address-wrapper">
          <div
            :class="{checked: current === address.id}"
            :key="index"
            class="address-item unchecked"
            v-for="(address, index) in addressList"
          >
            <button @click="switchTab(address.id, address)">{{address | fullAddress}}</button>
          </div>
        </div>
        <div class="choose-area-address">
          <button @click="switchChoose" class="switch-choose">选择其它地址</button>
        </div>
      </div>
      <div class="choose-area-options" v-if="showBack">
        <div class="area-nav">
          <ul class="nav-wrapper">
            <li
              :class="{'nav-checked': index === navCurrent}"
              :key="index"
              class="nav-item"
              v-for="(nav, index) in areaNav"
            >
              <button @click="switchNav(index)" class="province">{{nav}}</button>
            </li>
          </ul>
        </div>
        <div class="area-options auto-y">
          <!-- 省列表 -->
          <ul class="option-wrapper" v-if="navCurrent === 0">
            <li
              :class="{'checked-option': provinceCurrent === i}"
              :key="i"
              class="option-item"
              v-for="({name, code}, i) in provinceLists"
            >
              <button @click="switchProvince({i, name, code})" class="option">{{name}}</button>
            </li>
          </ul>
          <!-- 市列表 -->
          <ul class="option-wrapper" v-if="navCurrent === 1">
            <li
              :class="{'checked-option': cityCurrent === i}"
              :key="i"
              class="option-item"
              v-for="({code, name}, i) in cityLists"
            >
              <button @click="switchCity({i, code, name})" class="option">{{name}}</button>
            </li>
          </ul>
          <!-- 区列表 -->
          <ul class="option-wrapper" v-if="navCurrent === 2">
            <li
              :class="{'checked-option': districtCurrent === i}"
              :key="i"
              class="option-item"
              v-for="({code, name}, i) in districtLists"
            >
              <button @click="switchDistrict({i, name, code })" class="option">{{name}}</button>
            </li>
          </ul>
          <!-- 街道 -->
          <ul class="option-wrapper" v-if="navCurrent === 3">
            <li
              :class="{'checked-option': streetCurrent === i}"
              :key="i"
              class="option-item"
              v-for="({code, name}, i) in streetLists"
            >
              <button @click="switchStreet({i, code, name})" class="option">{{name}}</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import { mapState } from 'vuex'
import { Popup } from 'vant'
import api from '../../utils/api'
let flag = false
export default {
  components: {
    Popup
  },
  props: {
    show: {
      type: Boolean
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization',
      'currentSku'
    ]),
    ...mapState('goods', [
      'platform',
      'userQueryInventoryAddress'

    ]),
    modelTitle () {
      return this.showBack ? '选择区域' : '选择地址'
    }
  },
  filters: {
    fullAddress (address) {
      const street = address.town_name * 1 ? address.town_name : ''
      return address.province_name + address.city_name + address.district_name + street + address.address_detail
    }
  },
  data () {
    return {
      areaNav: ['请选择'],
      showBack: false,
      addressList: [],
      province: {
        province_code: 0,
        province_name: 0
      },
      city: {
        city_code: 0,
        city_name: 0
      },
      district: {
        district_code: 0,
        district_name: 0
      },
      street: {
        town_code: 0,
        town_name: 0
      },
      current: 0,
      navCurrent: 0,
      provinceCurrent: '',
      cityCurrent: '',
      districtCurrent: '',
      streetCurrent: '',
      provinceLists: [],
      cityLists: [],
      districtLists: [],
      streetLists: []
    }
  },
  mounted () {
    setTimeout(async () => {
      if (this.currentSku && this.currentSku.item_type !== 1) {
        return false
      }
      if (this.Authorization) {
        const status = await api.checkToken()
        if (!status) {
          this.showCheckAreaHandler()
          return false
        }
        await this.getUserAddress()
        this.current = this.userQueryInventoryAddress && this.userQueryInventoryAddress.id
        setTimeout(() => {
          this.getAddressdetails({ name: 'province' })
        }, 500)
      } else {
        this.showCheckAreaHandler()
      }
    }, 2000)
  },
  methods: {
    showCheckAreaHandler () {
      if (!this.addressList.length) {
        this.showBack = true
        this.getAddressdetails({ name: 'province' })
      }
    },
    finished () {
      this.$emit('update', {
        id: -1,
        ...this.province,
        ...this.city,
        ...this.district,
        ...this.street
      })
    },
    switchNav (i) {
      this.navCurrent = i
    },

    // 省列表切换
    async switchProvince ({ i, name, code }) {
      if (flag) {
        return
      }
      flag = true
      this.provinceCurrent = i
      this.cityCurrent = ''
      this.cityLists = []
      this.districtLists = []
      this.districtCurrent = ''
      this.streetLists = []
      this.streetCurrent = ''
      this.province = {
        province_code: code,
        province_name: name
      }
      if (this.areaNav.length > 1) {
        this.areaNav.splice(this.navCurrent, this.areaNav.length, name, '请选择')
      } else {
        this.areaNav.splice(this.navCurrent, 0, name)
      }

      this.navCurrent += 1
      await this.getAddressdetails({ name: 'city', code })
      flag = false
    },

    //  市列表切换
    async switchCity ({ i, name, code }) {
      if (flag) {
        return false
      }
      flag = true
      this.cityCurrent = i
      this.districtLists = []
      this.districtCurrent = ''
      this.streetLists = []
      this.streetCurrent = ''
      this.city = {
        city_code: code,
        city_name: name
      }
      if (this.areaNav.length > 2) {
        this.areaNav.splice(this.navCurrent, this.areaNav.length, name, '请选择')
      } else {
        this.areaNav.splice(this.navCurrent, 0, name)
      }
      this.navCurrent += 1
      await this.getAddressdetails({ name: 'district', code })
      flag = false
    },

    // 区列表切换
    async switchDistrict ({ i, name, code }) {
      if (flag) {
        return false
      }
      flag = true
      this.districtCurrent = i
      this.streetLists = []
      this.streetCurrent = ''
      this.district = {
        district_code: code,
        district_name: name
      }
      const status = await this.getAddressdetails({ name: 'street', code })
      if (!status) {
        this.areaNav.splice(this.navCurrent, 1, name)
        this.finished()
      } else {
        if (this.areaNav.length > 3) {
          this.areaNav.splice(this.navCurrent, this.areaNav.length, name, '请选择')
        } else {
          this.areaNav.splice(this.navCurrent, 0, name)
        }
        this.navCurrent += 1
      }
      flag = false
    },

    // 街道列表切换
    switchStreet ({ i, name, code }) {
      if (flag) {
        return false
      }
      flag = true
      this.streetCurrent = i
      this.street = {
        town_code: code,
        town_name: name
      }
      this.areaNav.splice(this.navCurrent, this.areaNav.length, name)
      this.finished()
      flag = false
    },

    switchTab (id, address) {
      this.current = id
      this.$emit('switch-address', address)
    },
    back () {
      this.showBack = false
    },

    switchChoose () {
      this.showBack = true
    },

    close () {
      if (this.show) {
        this.$emit('close')
      }
    },

    /**
     * 地址联动
     */
    async getAddressdetails ({ name, code }) {
      const res = await this.$axios.get(
        `api/address/yk/${this.platform.addr_data}/${code || 0}`
      )
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          this[`${name}Lists`] = data
          return true
        } else {
          return false
        }
      }
    },

    /**
     * 获取用户平台地址列表
     */
    async getUserAddress () {
      const res = await this.$axios.get(`api/address/list/${this.platform.name}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.addressList = data
        } else if (code === 9006) {
          this.showBack = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }

}
</script>

<style lang="less" scoped>
.address-choose {
  .title {
    position: relative;
    padding: 0 0.3rem;
    height: 0.8rem;
    border-bottom: 0.5px solid #ccc;
    font-size: @fz28;
    box-sizing: border-box;
    .flex-center;
    .back {
      position: absolute;
      left: 0.3rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: @fz24;
      color: @base;
      .flex-center;
      img {
        width: 0.2rem;
        height: 0.3rem;
        transform: rotate(180deg);
        object-fit: contain;
        padding-left: 0.1rem;
      }
    }
    .close {
      position: absolute;
      right: 0.3rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.74rem;
      height: 0.4rem;
      color: @c80;
      font-size: 0.2rem;
      border-radius: 15px;
      border: 1px solid #ccc;
    }
  }
  .user-address-list {
    height: 7.5rem;
    .address-wrapper {
      padding: 0 0.3rem;
    }
    .address-item {
      // display: flex;
      width: 100%;
      height: 0.4rem;
      font-size: @fz26;
      color: @base;
      padding-left: 0.34rem;
    }
    .unchecked {
      position: relative;
      margin-top: 0.34rem;
    }
    .unchecked::after {
      content: "";
      position: absolute;
      width: 0.24rem;
      height: 0.29rem;
      background: url("../../assets/img/goods-details/unchecked.png") center
        no-repeat;
      background-size: 100%;
      left: 0rem;
      top: 50%;
      transform: translateY(-50%);
    }
    .checked::after {
      content: "";
      position: absolute;
      width: 0.24rem;
      height: 0.16rem;
      background: url("../../assets/img/goods-details/checked.png") center
        no-repeat;
      background-size: 100%;
    }
  }
  .choose-area-address {
    height: 0.88rem;
    position: absolute;
    bottom: 0.2rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    .switch-choose {
      width: 7.03rem;
      height: 0.88rem;
      color: #fff;
      font-size: 0.34rem;
      background-color: #ff3824;
      border-radius: 30px;
    }
  }

  .choose-area-options {
    .area-nav {
      .nav-wrapper {
        padding: 0 0.4rem;
        height: 0.7rem;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ccc;
        font-size: @fz26;
        color: @base;
      }
      .nav-item {
        height: 100%;
        margin-right: 0.2rem;
        button {
          height: 100%;
        }
      }
      .nav-checked {
        position: relative;
        color: #f84e4e;
      }
      .nav-checked::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #f84e4e;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .area-options {
      height: 7.8rem;
      padding: 0.3rem 0.4rem 0;
      font-size: @fz26;
      color: @base;
      .option-item {
        margin-bottom: 0.3rem;
        .option {
          width: 100%;
          height: 100%;
          text-align: left;
        }
      }
      .checked-option {
        position: relative;
      }
      .checked-option::after {
        content: "";
        position: absolute;
        width: 0.24rem;
        height: 0.16rem;
        background: url("../../assets/img/goods-details/checked.png") center
          no-repeat;
        background-size: 100%;
        right: 0rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
